// Import model
import { DataviewOtgCarpetCatalogStyleResponse } from '../models/DataviewOtgCarpetCatalogStyleResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOtgCarpetCatalogStyleRequest } from '../models/FilterOtgCarpetCatalogStyleRequest';
import { OtgCarpetCatalogStyle } from '../models/OtgCarpetCatalogStyle';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOtgCarpetCatalogStyleRequestSerializer } from './FilterOtgCarpetCatalogStyleRequestSerializer';
import { OtgCarpetCatalogStyleSerializer } from './OtgCarpetCatalogStyleSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOtgCarpetCatalogStyleResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOtgCarpetCatalogStyleResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOtgCarpetCatalogStyleResponse instance
   */
  static deserialize(json: string): DataviewOtgCarpetCatalogStyleResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOtgCarpetCatalogStyleResponse instance
   */
  static fromObject(obj: any): DataviewOtgCarpetCatalogStyleResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOtgCarpetCatalogStyleResponse');
    }


    const instance: DataviewOtgCarpetCatalogStyleResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OtgCarpetCatalogStyleSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOtgCarpetCatalogStyleRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOtgCarpetCatalogStyleResponse instances
   */
  static deserializeArray(json: string): DataviewOtgCarpetCatalogStyleResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOtgCarpetCatalogStyleResponse instance to a JSON string
   */
  static serialize(instance: DataviewOtgCarpetCatalogStyleResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOtgCarpetCatalogStyleResponse instance to a plain object
   */
  static toObject(instance: DataviewOtgCarpetCatalogStyleResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OtgCarpetCatalogStyleSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOtgCarpetCatalogStyleRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOtgCarpetCatalogStyleResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOtgCarpetCatalogStyleResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
